/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CompositionProductVariantSummary } from './compositionProductVariantSummary';

export interface CompositionDetails {
  compositionId?: number;
  compositionName?: string;
  costTotal?: number;
  dateCreated?: Date;
  dateSyncERP?: Date;
  dateUpdated?: Date;
  editionId?: number;
  glamclubTradeCount?: number;
  invoiceTotal?: number;
  pendingPreparation?: number;
  productCount?: number;
  products?: Array<CompositionProductVariantSummary>;
  saleTotal?: number;
  subscriberCount?: number;
  weight?: number;
}
